export const months = [
    {
        name: 'Jan',
        displayName: 'January',
        value: 1,
    },
    {
        name: 'Feb',
        displayName: 'February',
        value: 2,
    },
    {
        name: 'Mar',
        displayName: 'March',
        value: 3,
    },
    {
        name: 'Apr',
        displayName: 'April',
        value: 4,
    },
    {
        name: 'May',
        displayName: 'May',
        value: 5,
    },
    {
        name: 'Jun',
        displayName: 'June',
        value: 6,
    },
    {
        name: 'Jul',
        displayName: 'July',
        value: 7,
    },
    {
        name: 'Aug',
        displayName: 'August',
        value: 8,
    },
    {
        name: 'Sep',
        displayName: 'September',
        value: 9,
    },
    {
        name: 'Oct',
        displayName: 'October',
        value: 10,
    },
    {
        name: 'Nov',
        displayName: 'November',
        value: 11,
    },
    {
        name: 'Dec',
        displayName: 'December',
        value: 12,
    },
];
